import styled from '@emotion/styled'

export const Step = styled.div`
  display: flex;
  gap: 1rem;
`
